import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

// One entry per AdBoostStatus (packages/db schema).
const STATUS_CLASS: Record<string, string> = {
  SUGGESTED: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  CREATING: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  PENDING: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  ACTIVE: "bg-green-500/10 text-green-400 border-green-500/20",
  PAUSED: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
  COMPLETED: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  REJECTED: "bg-red-500/10 text-red-400 border-red-500/20",
  FAILED: "bg-red-500/10 text-red-400 border-red-500/20",
  CANCELLED: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
};

export function BoostStatusBadge({ status, className }: { status: string; className?: string }) {
  const { t } = useTranslation("ads");
  const statusClass = STATUS_CLASS[status] ?? "";
  const label = STATUS_CLASS[status] !== undefined
    ? t(`status.${status}` as Parameters<typeof t>[0])
    : status;
  return (
    <Badge variant="outline" className={cn(statusClass, className)}>
      {label}
    </Badge>
  );
}
